import React from "react"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"
import Login from "./presentation/pages/Login"
import "bootstrap/dist/css/bootstrap.min.css"
import Dashboard from "./presentation/pages/Dashboard"
import FranchiseDetails from "./presentation/component/FranchiseDetails"
import { AuthProvider } from "presentation/context/AuthContext"
import ProtectedLayout from './presentation/layouts/ProtectedLayout'
import SupportUser from "./presentation/component/SupportUser"
import SideBarLayout from "./presentation/layouts/SideBarLayout"
import { SearchProvider } from "./presentation/context/SearchContext"
import ChangePassword from "./presentation/pages/ChangePassword"
import TerminalsDetails from "./presentation/component/TerminalsDetails"
import MyAccount from "./presentation/component/MyAccount"
/**
 * App component that manages routing, using AuthProvider to manage authentication state
 * and ProtectedLayout to group protected routes.
 */
const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Route: Login Page */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes: Grouped under ProtectedLayout */}
          <Route element={<ProtectedLayout />}>
            <Route element={<SideBarLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/supportuser" element={<SupportUser />} />
              <Route path="/terminals/:terminalId" element={<TerminalsDetails />} />
              <Route path="/myaccount" element={<MyAccount />} />
            </Route>
            <Route
              path="/franchise/:franchiseId"
              element={
                <SearchProvider>
                  <FranchiseDetails />
                </SearchProvider>
              }
            />
          </Route>

          {/* Catch-all Route: Redirect to Change password page if found temporary password while login */}
          <Route path="/change-password" element={<ChangePassword />} />

          {/* Catch-all Route: Redirect to login if route not found */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>

  )
}

export default App